// extracted by mini-css-extract-plugin
module.exports = {"content":"_3iMn_a","contentWrapper":"p7XHqy"};